"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var alertModuleApi = _interopRequireWildcard(require("@/api/systemAlertModule"));
var _editAlertModule = _interopRequireDefault(require("./editAlertModule.vue"));
var _permission = require("@/utils/permission");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    EditAlertModule: _editAlertModule.default
  },
  data: function data() {
    return {
      constants: this.$constants,
      listPram: {
        page: 1,
        limit: this.$constants.page.limit[0],
        moduleName: '',
        devUserId: null,
        testUserId: null,
        enabled: null,
        notSetType: null
      },
      listData: {
        list: [],
        total: 0
      },
      listLoading: false,
      adminList: []
    };
  },
  mounted: function mounted() {
    this.handlerGetAdminList();
    this.handlerGetListData();
  },
  methods: {
    checkPermi: _permission.checkPermi,
    handlerGetAdminList: function handlerGetAdminList() {
      var _this = this;
      alertModuleApi.getAdminList().then(function (data) {
        _this.adminList = data;
      });
    },
    resetSearch: function resetSearch() {
      this.listPram = {
        page: 1,
        limit: this.$constants.page.limit[0],
        moduleName: '',
        devUserId: null,
        testUserId: null,
        enabled: null,
        notSetType: null
      };
      this.handlerGetListData();
    },
    handerSearch: function handerSearch() {
      this.listPram.page = 1;
      this.handlerGetListData();
    },
    handlerGetListData: function handlerGetListData() {
      var _this2 = this;
      this.listLoading = true;
      alertModuleApi.getAlertModuleList(this.listPram).then(function (data) {
        // 转换ID字符串为数组，供多选下拉使用
        data.list.forEach(function (item) {
          item.devUserIdsArray = _this2.parseUserIds(item.devUserIds);
          item.testUserIdsArray = _this2.parseUserIds(item.testUserIds);
        });
        _this2.listData = data;
        _this2.listLoading = false;
      }).catch(function () {
        _this2.listLoading = false;
      });
    },
    parseUserIds: function parseUserIds(userIds) {
      if (!userIds) return [];
      return userIds.split(',').map(function (id) {
        return parseInt(id, 10);
      }).filter(function (id) {
        return !isNaN(id);
      });
    },
    handleSizeChange: function handleSizeChange(val) {
      this.listPram.limit = val;
      this.handlerGetListData();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.listPram.page = val;
      this.handlerGetListData();
    },
    handlerAdd: function handlerAdd() {
      this.$refs['editRef'].openInit();
    },
    handlerOpenEdit: function handlerOpenEdit(row) {
      this.$refs['editRef'].openInit(row);
    },
    handlerDelete: function handlerDelete(row) {
      var _this3 = this;
      this.$confirm("\u786E\u5B9A\u8981\u5220\u9664\u6A21\u5757\u3010".concat(row.moduleName, "\u3011\u5417\uFF1F"), '提示', {
        type: 'warning'
      }).then(function () {
        alertModuleApi.deleteAlertModule(row.id).then(function () {
          _this3.$message.success('删除成功');
          _this3.handerSearch();
        });
      }).catch(function () {});
    },
    onStatusChange: function onStatusChange(row) {
      var _this4 = this;
      alertModuleApi.changeAlertModuleStatus(row.id, row.enabled).then(function () {
        _this4.$message.success('状态更新成功');
      }).catch(function () {
        _this4.handerSearch();
      });
    },
    handleDropdownClose: function handleDropdownClose(row, type, visible) {
      var _this5 = this;
      if (visible) return;
      var userIds = type === 'dev' ? row.devUserIdsArray : row.testUserIdsArray;
      var userNames = userIds.map(function (id) {
        var admin = _this5.adminList.find(function (a) {
          return a.id === id;
        });
        return admin ? admin.realName : '';
      }).filter(function (name) {
        return name;
      }).join('、');
      this.$confirm("\u786E\u8BA4\u5C06\u5F53\u524D\u6A21\u5757\u7684\u5F00\u53D1/\u6D4B\u8BD5\u6539\u4E3A\u3010".concat(userNames, "\u3011\u5417\uFF1F"), '提示', {
        type: 'warning'
      }).then(function () {
        var data = {
          id: row.id,
          devUserIds: type === 'dev' ? userIds : _this5.parseUserIds(row.devUserIds),
          testUserIds: type === 'test' ? userIds : _this5.parseUserIds(row.testUserIds)
        };
        alertModuleApi.updateAlertModuleUsers(data).then(function () {
          _this5.$message.success('负责人更新成功');
          if (type === 'dev') {
            row.devUserIds = userIds.join(',');
            row.devUserNames = userNames;
          } else {
            row.testUserIds = userIds.join(',');
            row.testUserNames = userNames;
          }
        }).catch(function () {
          _this5.handerSearch();
        });
      }).catch(function () {
        if (type === 'dev') {
          row.devUserIdsArray = _this5.parseUserIds(row.devUserIds);
        } else {
          row.testUserIdsArray = _this5.parseUserIds(row.testUserIds);
        }
      });
    }
  }
};